export * from "/workspace/FreckleQueens/OpenSelves/willow-ts/bab_rs-wasm/pkg/bab_rs_wasm_bg.wasm?vite-wasm-instance";
import { __abort_handler as __vite__wasmGlobal_2, __instance_terminated as __vite__wasmGlobal_3 } from "/workspace/FreckleQueens/OpenSelves/willow-ts/bab_rs-wasm/pkg/bab_rs_wasm_bg.wasm?vite-wasm-instance";
let __abort_handler, __instance_terminated;
try { __abort_handler = __vite__wasmGlobal_2.value; } catch {}
try { __instance_terminated = __vite__wasmGlobal_3.value; } catch {}
export { __abort_handler, __instance_terminated };